export const formatPortAliases = (aliases: string[] | undefined) => {
    if (!aliases || !aliases.length) {
        return undefined;
    }
    return aliases.map((alias) => `"${alias}"`).join(', ');
};
